var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"employeeportal"}},[_c('f7-navbar',{attrs:{"title":"Employee Portal","back-link":"Back"}}),_vm._v(" "),_c('f7-list',[_c('f7-list-item',{attrs:{"link":"/vacations/","title":"Vacations"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }